import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../../../core/form-generator";
import {
  editInfantFormConfig,
  EXHAUST_SMOKE_CONDITIONS,
  STATUS_OPTIONS,
} from "./config";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import {
  getFileNameFromUrl,
  handleFormValidation,
  PAGE_LIMIT,
  splitFileName,
} from "../../../../utils";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiFileUpload from "../../../../core/file-uploader";
import CustomButtonComponent from "../../../../core/custom-button";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SiTextField from "../../../../core/si-textfield";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
import FreeServices from "../../../../components/ticket-form/free-services";
import PastHistory from "../../../../components/ticket-form/past-history";
import InfantChecklist from "./infant-checklist";
import { convertFreeServiceObjectToArray } from "../../../../components/create-ticket/helper";
import {
  infantChecklistAirSystem,
  mappingDetailsToUIAirSystem,
} from "./checklist/air-system-helper";
import {
  infantCareCoolantSystem,
  mappingDetailsToUICoolantCondition,
} from "./checklist/coolant-condition-helper";
import {
  infantChecklistElectricalSystem,
  mappingDetailsToUIElectricalSystem,
} from "./checklist/electrical-system-helper";
import {
  infantChecklistFuelSystem,
  mappingDetailsToUIFuelSystem,
} from "./checklist/fuel-system-helper";
import {
  infantChecklistLubeSystem,
  mappingDetailsToUILubeSystem,
} from "./checklist/lubrication-system-helper";
import {
  convertedData,
  formatFreeServicesPayload,
} from "../../../../components/ticket-form/helper";
import { STATE_LIST } from "../../../../utils/state-list";
const EditInfantCare = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({
    checkList: {
      electricalSystem: {},
      airSystem: {},
      fuelSystem: {},
      lubeSystem: {},
      coolantSystem: {},
    },
  });
  const [errors, setErrors] = useState({});
  const [oemsList, setOemsList] = useState([]);
  const [isFieldsUpdated, setIsFieldsUpdated] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [pastHistory, setPastHistory] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);

  const submitHandler = () => {
    const isValid = handleFormValidation(
      editInfantFormConfig(),
      setErrors,
      formData
    );

    if (isValid) {
      const formattedService = formatFreeServicesPayload(serviceList);
      const airSystem = infantChecklistAirSystem(
        formData?.checkList?.airSystem
      );
      const fuelSystem = infantChecklistFuelSystem(
        formData?.checkList?.fuelSystem
      );
      const lubeSystem = infantChecklistLubeSystem(
        formData?.checkList?.lubeSystem
      );
      const coolantSystem = infantCareCoolantSystem(
        formData?.checkList?.coolantSystem
      );
      const electricalSystem = infantChecklistElectricalSystem(
        formData?.checkList?.electricalSystem
      );
      const payload = {
        ...formData,
        exhaustSmokeCondition: formData?.exhaustSmokeCondition?.value,
        oem: formData?.oem?.value,
        state: formData?.state?.value,
        complaintsIfAny: formData?.complaintsIfAny?.code,
        iqaOnInjector: {
          cylinder1: formData?.iqaOnInjectorCylinder1,
          cylinder2: formData?.iqaOnInjectorCylinder2,
          cylinder3: formData?.iqaOnInjectorCylinder3,
          cylinder4: formData?.iqaOnInjectorCylinder4,
        },
        iqaInEcu: {
          cylinder1: formData?.iqaInEcuCylinder1,
          cylinder2: formData?.iqaInEcuCylinder2,
          cylinder3: formData?.iqaInEcuCylinder3,
          cylinder4: formData?.iqaInEcuCylinder4,
        },
        checkList: {
          electricalSystem: electricalSystem,
          airSystem: airSystem,
          fuelSystem: fuelSystem,
          lubeSystem: lubeSystem,
          coolantSystem: coolantSystem,
        },
        pastHistory: pastHistory,
        serviceHistory: formattedService,
      };
      delete payload.iqaOnInjectorCylinder1;
      delete payload.iqaOnInjectorCylinder2;
      delete payload.iqaOnInjectorCylinder3;
      delete payload.iqaOnInjectorCylinder4;

      delete payload.iqaInEcuCylinder1;
      delete payload.iqaInEcuCylinder2;
      delete payload.iqaInEcuCylinder3;
      delete payload.iqaInEcuCylinder4;

      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.INFANT_CARE}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success(" Updated Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };

  const getOemList = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemsList(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const saveServices = (newService) => {
    setServiceList([...serviceList, newService]);
    setErrors({
      ...errors,
      freeServicesErr: false,
    });
  };
  const loadComplaintCodes = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: r.code,
            };
          });
          setComplaintCodes(codes);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    getOemList();
    loadComplaintCodes();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      setFormData((prevVal) => ({
        ...prevVal,
        complaintsIfAny: complaintCodes?.find(
          (ele) => ele?.value === editData?.complaintsIfAny
        ),
        customerContactNumber: editData?.customerContactNumber,
        customerFeedbackRemarks: editData?.customerFeedbackRemarks,
        customerName: editData?.customerName,
        dateOfSale: new Date(editData?.dateOfSale),
        dateOfVisit: new Date(editData?.dateOfVisit),
        engineModel: editData?.engineModel,
        engineSerialNumber: editData?.engineSerialNumber,
        fuelFilter: editData?.fuelFilter,
        implementsUsed: editData?.implementsUsed,
        machineLocation: editData?.machineLocation,
        machineModel: editData?.machineModel,
        machineSerialNumber: editData?.machineSerialNumber,
        observation: editData?.observation,
        oem: oemsList?.find((ele) => ele?.value === editData?.oem?.id),
        oilFilterMake: editData?.oilFilterMake,
        remarks: editData?.remarks,
        state: STATE_LIST?.find((st) => st?.value === editData?.state),
        totalRunningHours: editData?.totalRunningHours,
        actionTaken: editData?.actionTaken,
        attachments: editData?.attachments,
        checkList: {
          electricalSystem: mappingDetailsToUIElectricalSystem(
            editData?.checkList?.electricalSystem || {}
          ),
          airSystem: mappingDetailsToUIAirSystem(
            editData?.checkList?.airSystem || {}
          ),
          fuelSystem: mappingDetailsToUIFuelSystem(
            editData?.checkList?.fuelSystem || {}
          ),
          lubeSystem: mappingDetailsToUILubeSystem(
            editData?.checkList?.lubeSystem || {}
          ),
          coolantSystem: mappingDetailsToUICoolantCondition(
            editData?.checkList?.coolantSystem || {}
          ),
        },
        dataSetId: editData?.dataSetId,
        ecuSoftwareVersion: editData?.ecuSoftwareVersion,
        errorCodeStatus: editData?.errorCodeStatus,
        exhaustSmokeCondition: EXHAUST_SMOKE_CONDITIONS?.find(
          (ele) => ele?.value === editData?.exhaustSmokeCondition
        ),
        hmiNo: editData?.hmiNo,
        hrsInObdTool: editData?.hrsInObdTool,
        iqaInEcuCylinder1: editData?.iqaInEcu?.cylinder1,
        iqaInEcuCylinder2: editData?.iqaInEcu?.cylinder2,
        iqaInEcuCylinder3: editData?.iqaInEcu?.cylinder3,
        iqaInEcuCylinder4: editData?.iqaInEcu?.cylinder4,

        iqaOnInjectorCylinder1: editData?.iqaOnInjector?.cylinder1,
        iqaOnInjectorCylinder2: editData?.iqaOnInjector?.cylinder2,
        iqaOnInjectorCylinder3: editData?.iqaOnInjector?.cylinder3,
        iqaOnInjectorCylinder4: editData?.iqaOnInjector?.cylinder4,

        oemRepresentative: editData?.oemRepresentative,
        prvCount: editData?.prvCount,
        prvDuration: editData?.prvDuration,
        simpsonRepresentative: editData?.simpsonRepresentative,
        vinNo: editData?.vinNo,
      }));

      setPastHistory(editData?.pastHistory || []);
      const data = convertedData(editData?.serviceHistory || []);
      setServiceList(data);
      setIsFieldsUpdated(true);
    }
  }, [oemsList, complaintCodes]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={editInfantFormConfig(oemsList, complaintCodes)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        {/* Error Code Status */}
        <div style={{ marginTop: "24px" }}>
          <Typography variant="h6">
            Error Code Status{" "}
            <CustomButtonComponent
              variant="text"
              color="primary"
              onClick={() => {
                const updated = [...(formData.errorCodeStatus || [])];
                updated.push({});
                setFormData((prev) => ({ ...prev, errorCodeStatus: updated }));
              }}
            >
              + Add Error Code
            </CustomButtonComponent>
          </Typography>

          {(formData.errorCodeStatus || [{}]).map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr 0.2fr",
                gridGap: 10,
                marginRight: 5,
                marginTop: 1,
              }}
            >
              <SiTextField
                placeholder="Enter P-Code"
                value={row.pCode || ""}
                onChange={(e) => {
                  const updated = [...(formData.errorCodeStatus || [])];
                  updated[index] = { ...updated[index], pCode: e.target.value };
                  setFormData((prev) => ({
                    ...prev,
                    errorCodeStatus: updated,
                  }));
                }}
              />

              <SiAutocomplete
                options={STATUS_OPTIONS}
                placeholder="Select Status"
                value={
                  STATUS_OPTIONS.find((opt) => opt?.value === row.status) ||
                  null
                }
                onChange={(selected) => {
                  const updated = [...(formData.errorCodeStatus || [])];
                  updated[index] = {
                    ...updated[index],
                    status: selected?.value || "",
                  };
                  setFormData((prev) => ({
                    ...prev,
                    errorCodeStatus: updated,
                  }));
                }}
              />

              <SiTextField
                placeholder="Enter Lamp Status"
                value={row.lampStatus || ""}
                onChange={(e) => {
                  const updated = [...(formData.errorCodeStatus || [])];
                  updated[index] = {
                    ...updated[index],
                    lampStatus: e.target.value,
                  };
                  setFormData((prev) => ({
                    ...prev,
                    errorCodeStatus: updated,
                  }));
                }}
              />

              <SiTextField
                placeholder="Enter Description"
                value={row.description || ""}
                onChange={(e) => {
                  const updated = [...(formData.errorCodeStatus || [])];
                  updated[index] = {
                    ...updated[index],
                    description: e.target.value,
                  };
                  setFormData((prev) => ({
                    ...prev,
                    errorCodeStatus: updated,
                  }));
                }}
              />

              {/* Delete row button */}
              {index > 0 && (
                <IconButton
                  color="error"
                  onClick={() => {
                    const updated = [...formData.errorCodeStatus];
                    updated.splice(index, 1);
                    setFormData((prev) => ({
                      ...prev,
                      errorCodeStatus: updated,
                    }));
                  }}
                >
                  <CancelOutlinedIcon />
                </IconButton>
              )}
            </Box>
          ))}
        </div>
        <div className="history-services">
          <FreeServices
            onSave={saveServices}
            serviceList={serviceList}
            onDelete={(newHistory) => setServiceList(newHistory)}
            formData={formData}
            error={errors.freeServicesErr || false}
          />

          <PastHistory
            onSave={(newHistory) =>
              setPastHistory([...pastHistory, newHistory])
            }
            pastHistory={pastHistory}
            onDelete={(newHistory) => setPastHistory(newHistory)}
          />
        </div>
      </div>
      {isFieldsUpdated && (
        <div className="form-con" style={{ width: "100%" }}>
          <InfantChecklist details={formData} setDetails={setFormData} />
        </div>
      )}

      <div className="form-con" style={{ width: "100%" }}>
        <div>
          <Typography variant="h6" sx={{ mb: 3 }}>
            Attachments
          </Typography>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            {formData?.oemRepresentative && (
              <a
                className="open-link"
                href={splitFileName(formData.oemRepresentative)}
                target="_blank"
              >
                OEM Representative Signature
              </a>
            )}
            {formData?.simpsonRepresentative && (
              <a
                className="open-link"
                href={splitFileName(formData.simpsonRepresentative)}
                target="_blank"
              >
                Simpson Representative Signature
              </a>
            )}

            {formData?.attachments?.length > 0 &&
              formData.attachments.map((document, index) => (
                <a
                  key={index}
                  className="open-link"
                  href={splitFileName(document)}
                  target="_blank"
                >
                  Document {index + 1}
                </a>
              ))}
          </Box>
        </div>
        <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-end", mr: 2 }}>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default EditInfantCare;
